import {Clear, DeleteOutline} from '@mui/icons-material'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Button,
  ButtonProps,
  DialogProps
} from '@mui/material'
import React from 'react'

interface DeletionModalProps {
  open: boolean
  message: React.ReactNode
  cancelButtonCaption: string
  confirmButtonCaption: string
  onConfirm: () => void
  onCancel: () => void
  title?: string
  cancelButtonProps?: ButtonProps
  confirmButtonProps?: ButtonProps
  cancelButtonTestId?: string
  confirmButtonTestId?: string
  onClose?: () => void
  dialogProps?: Omit<DialogProps, 'open' | 'onClose'>
}

export const DeletionModal: React.FC<DeletionModalProps> = ({
  open,
  message,
  cancelButtonCaption,
  confirmButtonCaption,
  onCancel,
  onConfirm,
  title,
  cancelButtonProps,
  confirmButtonProps,
  cancelButtonTestId,
  confirmButtonTestId,
  onClose,
  dialogProps
}) => {
  return (
    <Dialog open={open} onClose={onClose || onCancel} {...dialogProps}>
      {title && (
        <>
          <DialogTitle sx={{fontSize: '20px', fontWeight: 600, pb: 2}}>{title}</DialogTitle>
          <Divider />
        </>
      )}
      <DialogContent sx={{minWidth: {sm: 400}, pt: title ? 3 : undefined}}>{message}</DialogContent>
      <DialogActions>
        <Button
          color={'secondary'}
          onClick={onCancel}
          startIcon={<Clear />}
          data-test-id={cancelButtonTestId}
          {...cancelButtonProps}
        >
          {cancelButtonCaption}
        </Button>
        <Button
          color={'error'}
          variant={'contained'}
          onClick={onConfirm}
          startIcon={<DeleteOutline />}
          data-test-id={confirmButtonTestId}
          {...confirmButtonProps}
        >
          {confirmButtonCaption}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
